var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0836 31.35C17.3069 31.35 15.8219 29.6633 15.6202 27.5H11.5869C11.8069 31.515 14.8136 33.77 18.3336 34.5217V38.5H23.8336V34.5583C27.4086 33.88 30.2502 31.8083 30.2502 28.05C30.2502 22.8433 25.7952 21.065 21.6336 19.9833C17.4719 18.9017 16.1336 17.7833 16.1336 16.0417C16.1336 14.0433 17.9852 12.65 21.0836 12.65C24.3469 12.65 25.5569 14.2083 25.6669 16.5H29.7186C29.5902 13.3467 27.6652 10.45 23.8336 9.515V5.5H18.3336V9.46C14.7769 10.23 11.9169 12.54 11.9169 16.0783C11.9169 20.3133 15.4186 22.4217 20.5336 23.65C25.1169 24.75 26.0336 26.3633 26.0336 28.0683C26.0336 29.3333 25.1352 31.35 21.0836 31.35Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.73ec7d41.svg";
export { ForwardRef as ReactComponent };